import styles from './TabBar.module.scss';

interface Tab {
  id: string;
  label: string;
}

interface TabBarProps {
  tabs: ReadonlyArray<Tab>;
  activeTab: string;
  /** Called with the tab id when a tab is clicked. If activeTab does not match
   *  any tab id, no tab receives the active class — this is a caller contract. */
  onChange: (id: string) => void;
}

export function TabBar({ tabs, activeTab, onChange }: TabBarProps) {
  return (
    <div role="tablist" className={styles.tabBar}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={isActive ? 'true' : 'false'}
            className={[styles.tab, isActive ? styles.active : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default TabBar;
